import date from '@/ddv2.library/date'
import google from '@/ddv2.library/utils/google'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
// import message from '@/ddv2.library/messages'
// import modals from '@/ddv2.library/modals'
import d2fmt from '@/ddv2.library/utils/formatter'

import complements from '@/rahmen/complement'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'

import flowMixin from '@/mixins/flowMixins'

import { mapGetters } from 'vuex'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdCalcDistance = () => import('@/components/DdCalcDistance.vue')
const DdCalcTankaButton = () => import('@/components/DdCalcTankaButton.vue')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdIconButton = () => import('@/components/DdIconButton')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTimeBoxSwitching = () => import('@/components/DdTimeBoxSwitching')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxPlaceHolderFree = () => import('@/components/DdTextBoxPlaceHolderFree')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')

export default {
  name: 'MstTeikeiCorceEditVerPackage',
  mixins: [flowMixin],
  components: {
    DdCalcDistance,
    DdCalcTankaButton,
    DdCustomButton,
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdDateBox,
    DdDefaultButton,
    DdDropDown,
    DdEditCommonBar,
    DdFooterButton,
    DdIconButton,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdSubHeader,
    DdTimeBoxSwitching,
    DdTextBox,
    DdTextBoxPlaceHolderFree,
    DdTextBoxSwitching,
    DdTransparentButton
  },
  data: () => ({
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    rec: {},
    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    baseYmd: date.getCurrentDate(),
    mapData: [],

    modeKengen: 2, // 0:読み取り専用,1:削除不可,2:フルアクセス
    modeOfEdit: 0,

    hinmeiSwitch: false,
    hatsuchiSwitch: false,
    hatsuchiHmsSwitch: false,
    chakuchiSwitch: false,
    chakuchiHmsSwitch: false,
    expandKeiyuchi: false,
    autoIssueNoMode: true,
    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders

  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd'
    }),
    // ----------------------------------------------------------------------------------------------------
    // マスタヘルプフィルタ
    // ----------------------------------------------------------------------------------------------------
    // 営業所
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 得意先
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 品名
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地
    filteredHacchakuchiList () {
      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    filteredHacchakuchiListLite () {
      if (!this.expandKeiyuchi) {
        return []
      }

      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // 区分種別フィルタ
    // ----------------------------------------------------------------------------------------------------
    // 往復種別
    filteredOhfukuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },
    // 品目種別フィルター
    filteredHinmokuShubetsuList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVIJ02')
    },
    // ----------------------------------------------------------------------------------------------------
    // 金額計算
    // ----------------------------------------------------------------------------------------------------
    calcSeikyuKingakuAmount () {
      let amount = 0

      if (this.hikazeiKingakuAmount > 0 || this.unchinAddWarimashiKingakuAmout > 0) {
        amount = parseInt(this.hikazeiKingakuAmount, 10) + parseInt(this.unchinAddWarimashiKingakuAmout, 10)
      }

      return amount
    },
    calcUnchin () {
      let amount = 0

      let tanka = this.rec.tanka

      if (tanka === undefined || tanka === '' || tanka === null) { tanka = '0' }

      if (this.rec.unchinKeisanKbn === '01') {
        let juchuSuryo = this.rec.juchuSuryo
        if (juchuSuryo === undefined || juchuSuryo === '' || juchuSuryo === null) { juchuSuryo = '0' }
        juchuSuryo = d2fmt.removeComma(juchuSuryo)
        amount = parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
      } else if (this.rec.unchinKeisanKbn === '02') {
        let juchuJuryo = this.rec.juchuJuryo
        if (juchuJuryo === undefined || juchuJuryo === '' || juchuJuryo === null) { juchuJuryo = '0' }
        juchuJuryo = d2fmt.removeComma(juchuJuryo)
        amount = parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
      } else if (this.rec.unchinKeisanKbn === '03') {
        amount = parseFloat(tanka, 10)
      }

      amount = this.calcFraction(amount)

      return amount
    },
    unchinKingakuAmount () {
      let hokanKingaku = this.rec.hokanKingaku
      let niekiKingaku = this.rec.niekiKingaku
      let unchinHokaKingaku = this.rec.unchinHokaKingaku
      let nenryoSurcharge = this.rec.nenryoSurcharge
      let tsumikomiKingaku = this.rec.tsumikomiKingaku
      let torioroshiKingaku = this.rec.torioroshiKingaku
      let taikiJikanKingaku = this.rec.taikiJikanKingaku
      let futaiGyomuKingaku = this.rec.futaiGyomuKingaku

      if (hokanKingaku === undefined || hokanKingaku === '' || hokanKingaku === null) { hokanKingaku = '0' }
      if (niekiKingaku === undefined || niekiKingaku === '' || niekiKingaku === null) { niekiKingaku = '0' }
      if (unchinHokaKingaku === undefined || unchinHokaKingaku === '' || unchinHokaKingaku === null) { unchinHokaKingaku = '0' }
      if (nenryoSurcharge === undefined || nenryoSurcharge === '' || nenryoSurcharge === null) { nenryoSurcharge = '0' }
      if (tsumikomiKingaku === undefined || tsumikomiKingaku === '' || tsumikomiKingaku === null) { tsumikomiKingaku = '0' }
      if (torioroshiKingaku === undefined || torioroshiKingaku === '' || torioroshiKingaku === null) { torioroshiKingaku = '0' }
      if (taikiJikanKingaku === undefined || taikiJikanKingaku === '' || taikiJikanKingaku === null) { taikiJikanKingaku = '0' }
      if (futaiGyomuKingaku === undefined || futaiGyomuKingaku === '' || futaiGyomuKingaku === null) { futaiGyomuKingaku = '0' }

      let amount = 0

      amount = parseInt(this.calcUnchin, 10) +
                parseInt(hokanKingaku, 10) +
                parseInt(niekiKingaku, 10) +
                parseInt(unchinHokaKingaku, 10) +
                parseInt(nenryoSurcharge, 10) +
                parseInt(tsumikomiKingaku, 10) +
                parseInt(torioroshiKingaku, 10) +
                parseInt(taikiJikanKingaku, 10) +
                parseInt(futaiGyomuKingaku, 10)

      return amount
    },
    hikazeiKingakuAmount () {
      let hiwayPrice = this.rec.hiwayPrice
      let unchinHokaHikazei = this.rec.unchinHokaHikazei
      let tatekaekinHikazei = this.rec.tatekaekinHikazei

      if (hiwayPrice === undefined || hiwayPrice === '' || hiwayPrice === null) { hiwayPrice = '0' }
      if (unchinHokaHikazei === undefined || unchinHokaHikazei === '' || unchinHokaHikazei === null) { unchinHokaHikazei = '0' }
      if (tatekaekinHikazei === undefined || tatekaekinHikazei === '' || tatekaekinHikazei === null) { tatekaekinHikazei = '0' }

      let amount = 0

      amount = parseInt(hiwayPrice, 10) + parseInt(unchinHokaHikazei, 10) + parseInt(tatekaekinHikazei, 10)

      return amount
    },
    warimashiKingakuAmount () {
      let jikanWarimashiKingaku = this.rec.jikanWarimashiKingaku
      let kyoriWarimashiKingaku = this.rec.kyoriWarimashiKingaku
      let warimashiSonotaKingaku = this.rec.warimashiSonotaKingaku

      if (jikanWarimashiKingaku === undefined || jikanWarimashiKingaku === '' || jikanWarimashiKingaku === null) { jikanWarimashiKingaku = '0' }
      if (kyoriWarimashiKingaku === undefined || kyoriWarimashiKingaku === '' || kyoriWarimashiKingaku === null) { kyoriWarimashiKingaku = '0' }
      if (warimashiSonotaKingaku === undefined || warimashiSonotaKingaku === '' || warimashiSonotaKingaku === null) { warimashiSonotaKingaku = '0' }

      let amount = 0

      amount = parseInt(jikanWarimashiKingaku, 10) + parseInt(kyoriWarimashiKingaku, 10) + parseInt(warimashiSonotaKingaku, 10)

      return amount
    },
    unchinAddWarimashiKingakuAmout () {
      let amount = 0

      amount = parseInt(this.unchinKingakuAmount, 10) + parseInt(this.warimashiKingakuAmount, 10)

      return amount
    },

    // ----------------------------------------------------------------------------------------------------
    // 項目制御
    // ----------------------------------------------------------------------------------------------------
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisp () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isReadOnlyBase () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return true
      }
      return false
    },
    isMapUsable () {
      if ((this.rec.hatsuchiId) ||
          (this.rec.keiyuchiId1) ||
          (this.rec.keiyuchiId2) ||
          (this.rec.keiyuchiId3) ||
          (this.rec.keiyuchiId4) ||
          (this.rec.keiyuchiId5) ||
          (this.rec.chakuchiId)) {
        return true
      }
      return false
    }
  },

  created () {
    this.id = this.$route.params.id
    this.id = (this.id === '0') ? 0 : this.id
  },

  mounted () {
    this.initialize()
  },

  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec,
        hinmeiSwitch: this.hinmeiSwitch,
        hatsuchiSwitch: this.hatsuchiSwitch,
        chakuchiSwitch: this.chakuchiSwitch,
        hatsuchiHmsSwitch: this.hatsuchiHmsSwitch,
        chakuchiHmsSwitch: this.chakuchiHmsSwitch,
        expandKeiyuchi: this.expandKeiyuchi
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // データ抽出処理
    // ----------------------------------------------------------------------------------------------------
    fetchData: function () {
      return new Promise((resolve) => {
        console.log(this.id)
        // /* eslint no-debugger: "warn" */
        // debugger

        this.HttpClient
          .get(`/api/v1/VwCD2mstd0460/Find?id=${this.id}`)
          .then((data) => {
            if (data.payload) {
              const x = data.payload

              if (x.hatsuchiHms) {
                x.hatsuchiHms = complements.parseTime(x.hatsuchiHms, false).substr(0, 5)
              }
              if (x.chakuchiHms) {
                x.chakuchiHms = complements.parseTime(x.chakuchiHms, false).substr(0, 5)
              }
              if (x.yoteiSagyoJikan !== null && x.yoteiSagyoJikan !== undefined) {
                x.yoteiSagyoJikan = filter.minToTimeFormatter(x.yoteiSagyoJikan)
              }
              if (x.taikiJikan !== null && x.taikiJikan !== undefined) {
                x.taikiJikan = filter.minToTimeFormatter(x.taikiJikan)
              }
              if (x.warimashiTaishoJikan !== null && x.warimashiTaishoJikan !== undefined) {
                x.warimashiTaishoJikan = filter.minToTimeFormatter(x.warimashiTaishoJikan)
              }
              this.rec = x

              this.hinmeiSwitch = Boolean(!this.rec.mstHinmeiId && this.rec.hinmeiBiko)
              this.hatsuchiSwitch = Boolean(!this.rec.hatsuchiId && this.rec.hatsuchiBiko)
              this.hatsuchiHmsSwitch = Boolean(!this.rec.hatsuchiHms && this.rec.hatsuchiHmsBiko)
              this.chakuchiSwitch = Boolean(!this.rec.chakuchiId && this.rec.chakuchiBiko)
              this.chakuchiHmsSwitch = Boolean(!this.rec.chakuchiHms && this.rec.chakuchiHmsBiko)
              this.expandKeiyuchi = Boolean(this.rec.keiyuchiId2 || this.rec.keiyuchiId2Biko || this.rec.keiyuchiId3 || this.rec.keiyuchiId3Biko || this.rec.keiyuchiId4 || this.rec.keiyuchiId4Biko || this.rec.keiyuchiId5 || this.rec.keiyuchiId5Biko)

              // クローン情報設定
              this.cloneData = dolly.clone(this.getCloneTargetMethod())
            }
          })
        resolve()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 初期化処理
    // ----------------------------------------------------------------------------------------------------
    initialize () {
      const self = this
      const option = {
        loadMasters: [
          'msttorihikisaki',
          'msteigyosho',
          'msthinmei',
          'msthacchakuchi',
          'vwcmsteigyoshojininlist',
          'vwcmstsharyo',
          'msyskubun',
          'mstshubetsu'
        ],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            self.$nextTick(() => {
              self.autoIssueNoMode = c.autoIssueNoMode == null ? true : c.autoIssueNoMode === true || c.autoIssueNoMode === 'true'
            })
            resolve()
          })
        },
        existsIdMethod: function () {
          return self.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            // 権限制御
            if (kengen.kengenKbn === '10') {
              self.modeKengen = 0 // 読取モード
            } else if (kengen.kengenKbn === '20') {
              self.modeKengen = 1 // 削除不可モード
            } else {
              self.modeKengen = 2 // フルアクセス
            }

            // 画面モード設定
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForRegister(option)
    },
    // ----------------------------------------------------------------------------------------------------
    // 戻るボタン押下
    // ----------------------------------------------------------------------------------------------------
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // キャンセルボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.hinmeiSwitch = self.cloneData.hinmeiSwitch
            self.hatsuchiSwitch = self.cloneData.hatsuchiSwitch
            self.chakuchiSwitch = self.cloneData.chakuchiSwitch
            self.hatsuchiHmsSwitch = self.cloneData.hatsuchiHmsSwitch
            self.chakuchiHmsSwitch = self.cloneData.chakuchiHmsSwitch
            self.expandKeiyuchi = self.cloneData.expandKeiyuchi
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // 削除ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.convertToDBType()
            self.HttpClient.post('/api/v1/VwCD2mstd0460/Delete', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            this.convertToDispType()
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },

    // ----------------------------------------------------------------------------------------------------
    // 複写ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.rec.MstTeikeiKihonJuchuId = -1
          self.rec.MstTeikeiHinmokuJuchuId = -1
          self.rec.MstTeikeiKihonSagyoId = -1
          self.rec.MstTeikeiCourceSagyoId = -1
          self.rec.MstTeikeiHinmokuSagyoId = -1
          self.rec.MstTeikeiKihonHacchuId = -1
          self.rec.MstTeikeiCourceHacchuId = -1
          self.rec.MstTeikeiHinmokuHacchuId = -1
          self.rec.teikeiCourseNo = null
          self.modeOfEdit = 0
        }
      }
      this.copyInputs(opt)
    },
    // ----------------------------------------------------------------------------------------------------
    // 保存ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onSaveButtonClick: function (e) {
      this.rec.KihonUnchin = this.calcUnchin
      const self = this
      self.rec.autoIssueNoMode = self.autoIssueNoMode
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            self.rec = data.payload
            if (self.rec.hatsuchiHms) {
              self.rec.hatsuchiHms = complements.parseTime(self.rec.hatsuchiHms, false).substr(0, 5)
            }
            if (self.rec.chakuchiHms) {
              self.rec.chakuchiHms = complements.parseTime(self.rec.chakuchiHms, false).substr(0, 5)
            }
            self.autoIssueNoMode = true
            self.convertToDispType()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {
            autoIssueNoMode: self.autoIssueNoMode
          }
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            this.convertToDispType()
            resolve()
          })
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      this.convertToDBType()
      const f = this.HttpClient.post('/api/v1/VwCD2mstd0460/Create', this.rec)
      return f
    },
    registerValidate: function () {
      return true
    },
    convertToDBType: function () {
      if (this.rec.taikiJikan) {
        this.rec.taikiJikan = filter.timeToMinFormatter(this.rec.taikiJikan)
      }
      if (this.rec.yoteiSagyoJikan) {
        this.rec.yoteiSagyoJikan = filter.timeToMinFormatter(this.rec.yoteiSagyoJikan)
      }
      if (this.rec.warimashiTaishoJikan) {
        this.rec.warimashiTaishoJikan = filter.timeToMinFormatter(this.rec.warimashiTaishoJikan)
      }
    },
    convertToDispType: function () {
      if (this.rec.taikiJikan !== null && this.rec.taikiJikan !== undefined) {
        this.rec.taikiJikan = filter.minToTimeFormatter(this.rec.taikiJikan)
      }
      if (this.rec.yoteiSagyoJikan !== null && this.rec.yoteiSagyoJikan !== undefined) {
        this.rec.yoteiSagyoJikan = filter.minToTimeFormatter(this.rec.yoteiSagyoJikan)
      }
      if (this.rec.warimashiTaishoJikan !== null && this.rec.warimashiTaishoJikan !== undefined) {
        this.rec.warimashiTaishoJikan = filter.minToTimeFormatter(this.rec.warimashiTaishoJikan)
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // GoogleMapリンク
    // ----------------------------------------------------------------------------------------------------
    onMapViewClick: function (target) {
      // 初期化
      this.mapData = []
      // 発地設定
      if ((this.rec.hatsuchiId) && this.rec.hatsuchiId !== '' && this.rec.hatsuchiId !== null) {
        const hatsuchi = {
          id: this.rec.hatsuchiId,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(hatsuchi)
        } else {
          this.mapData = [hatsuchi]
        }
      }
      // 経由地１ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId1) && this.rec.keiyuchiId1 !== '' && this.rec.keiyuchiId1 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId1,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地２ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId2) && this.rec.keiyuchiId2 !== '' && this.rec.keiyuchiId2 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId2,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地３ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId3) && this.rec.keiyuchiId3 !== '' && this.rec.keiyuchiId3 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId3,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地４ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId4) && this.rec.keiyuchiId4 !== '' && this.rec.keiyuchiId4 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId4,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地５ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId5) && this.rec.keiyuchiId5 !== '' && this.rec.keiyuchiId5 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId5,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 着地設定
      if ((this.rec.chakuchiId) && this.rec.chakuchiId !== '' && this.rec.chakuchiId !== null) {
        const chakuchi = {
          id: this.rec.chakuchiId,
          ymdhms: this.baseYmd + (this.rec.chakuchiHms !== undefined && this.rec.chakuchiHms !== null && this.rec.chakuchiHms !== '' ? this.rec.chakuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(chakuchi)
        } else {
          this.mapData = [chakuchi]
        }
      }

      const url = 'https://www.google.com/maps/dir' + google.getAddressStrings(this.hacchakuchiList, this.mapData)
      window.open(url, '_blank')
    },

    // --------------------------------------------------------------------------------
    // 発着経由地入れ替え
    // --------------------------------------------------------------------------------
    onHatsuChakuReplace: function () {
      var tempHatsuChakuInfo = {
        hatsuchiId: this.rec.hatsuchiId,
        hatsuchiBiko: this.rec.hatsuchiBiko,
        keiyuchiId1: this.rec.keiyuchiId1,
        keiyuchiBiko1: this.rec.keiyuchiBiko1,
        keiyuchiId2: this.rec.keiyuchiId2,
        keiyuchiBiko2: this.rec.keiyuchiBiko2,
        keiyuchiId3: this.rec.keiyuchiId3,
        keiyuchiBiko3: this.rec.keiyuchiBiko3,
        keiyuchiId4: this.rec.keiyuchiId4,
        keiyuchiBiko4: this.rec.keiyuchiBiko4,
        keiyuchiId5: this.rec.keiyuchiId5,
        keiyuchiBiko5: this.rec.keiyuchiBiko5,
        chakuchiId: this.rec.chakuchiId,
        chakuchiBiko: this.rec.chakuchiBiko
      }

      // 既存値初期化
      this.rec.hatsuchiId = null
      this.rec.hatsuchiBiko = null
      this.rec.keiyuchiId1 = null
      this.rec.keiyuchiBiko1 = null
      this.rec.keiyuchiId2 = null
      this.rec.keiyuchiBiko2 = null
      this.rec.keiyuchiId3 = null
      this.rec.keiyuchiBiko3 = null
      this.rec.keiyuchiId4 = null
      this.rec.keiyuchiBiko4 = null
      this.rec.keiyuchiId5 = null
      this.rec.keiyuchiBiko5 = null
      this.rec.chakuchiId = null
      this.rec.chakuchiBiko = null

      if (![undefined, null, ''].includes(tempHatsuChakuInfo.chakuchiId)) {
        this.rec.hatsuchiId = tempHatsuChakuInfo.chakuchiId
        this.rec.hatsuchiBiko = tempHatsuChakuInfo.chakuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.hatsuchiId)) {
        this.rec.chakuchiId = tempHatsuChakuInfo.hatsuchiId
        this.rec.chakuchiBiko = tempHatsuChakuInfo.hatsuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId5)) {
        this.rec.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId5
        this.rec.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko5
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId4)) {
        if ([undefined, null, ''].includes(this.rec.keiyuchiId1)) {
          this.rec.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId4
          this.rec.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko4
        } else {
          this.rec.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId4
          this.rec.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko4
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId3)) {
        if ([undefined, null, ''].includes(this.rec.keiyuchiId1)) {
          this.rec.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId3
          this.rec.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko3
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId2)) {
          this.rec.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId3
          this.rec.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko3
        } else {
          this.rec.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId3
          this.rec.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko3
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId2)) {
        if ([undefined, null, ''].includes(this.rec.keiyuchiId1)) {
          this.rec.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId2
          this.rec.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId2)) {
          this.rec.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId2
          this.rec.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId3)) {
          this.rec.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId2
          this.rec.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko2
        } else {
          this.rec.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId2
          this.rec.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko2
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId1)) {
        if ([undefined, null, ''].includes(this.rec.keiyuchiId1)) {
          this.rec.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId1
          this.rec.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId2)) {
          this.rec.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId1
          this.rec.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId3)) {
          this.rec.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId1
          this.rec.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.rec.keiyuchiId4)) {
          this.rec.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId1
          this.rec.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko1
        } else {
          this.rec.keiyuchiId5 = tempHatsuChakuInfo.keiyuchiId1
          this.rec.keiyuchiBiko5 = tempHatsuChakuInfo.keiyuchiBiko1
        }
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 初期値設定
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      // this.baseYmd = date.getCurrentDate()
      // 入力項目
      this.rec.tantoEigyoshoId = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, this.baseYmd).id

      // 入力制御
      this.modeKengen = 0
      this.modeOfEdit = 0
      this.hinmeiSwitch = false
      this.hatsuchiSwitch = false
      this.hatsuchiHmsSwitch = false
      this.chakuchiSwitch = false
      this.chakuchiHmsSwitch = false
      this.expandKeiyuchi = false
      this.autoIssueNoMode = true
    },

    // ----------------------------------------------------------------------------------------------------
    // 金額項目設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 得意先IDが入力されたら、金額項目設定情報を取得メソッドを呼ぶ
    changeTokuisaki: function () {
      if (!this.rec.tokuisakiId) {
        this.rec.unchinHasuKeisanKbn = null
        return
      }
      console.log('changeTokuisakiId')
      this.rec.tokuisakiCd = indexeddb.getRecord(this.torihikisakiList, this.rec.tokuisakiId).torihikisakiCd
      this.getTokuisakiInfo(this.rec.tokuisakiId)
    },
    getTokuisakiInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/VwCD2mstd0460/MstTokuisakiInfoFind?id=${this.rec.tokuisakiId}`)
          .then((data) => {
            this.recTokuisakiInfo = data.payload
            console.log('getTokuisakiInfo', this.recTokuisakiInfo)
            if (!this.rec.unchinKeisanKbn && this.recTokuisakiInfo.unchinKeisanKbn) {
              this.$set(this.rec, 'unchinKeisanKbn', this.recTokuisakiInfo.unchinKeisanKbn)
            }
            this.rec.unchinHasuKeisanKbn = this.recTokuisakiInfo.unchinHasuKeisanKbn
            this.rec.warimashiJikanTanka = this.rec.warimashiJikanTanka ? this.rec.warimashiJikanTanka : this.recTokuisakiInfo.warimashiJikanTanka
            this.rec.warimashiKyoriTanka = this.rec.warimashiKyoriTanka ? this.rec.warimashiKyoriTanka : this.recTokuisakiInfo.warimashiKyoriTanka
          })
        resolve()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 請求予定日初期値設定
    // ----------------------------------------------------------------------------------------------------
    initSeikyuYoteiYmd: function () {
      const keijobiKbn = this.recTokuisakiInfo.keijobiKbn

      if (keijobiKbn === undefined || keijobiKbn === null || keijobiKbn === '') { return }

      if (this.recHaisoMeisai.seikyuYoteiYmd !== filter.dateFormatter(new Date()) && !this.recHaisoMeisai.meisaiOrder) { return }

      if (this.recHaisoMeisai.seikyuYoteiYmd && this.recHaisoMeisai.meisaiOrder) { return }

      if (keijobiKbn === '1' && this.recHaisoMeisai.hatsuchiYmd !== null && this.recHaisoMeisai.hatsuchiYmd !== '' && this.recHaisoMeisai.hatsuchiYmd !== undefined) {
        this.$refs.seikyuYoteiYmd.onCalendarInput(this.recHaisoMeisai.hatsuchiYmd)
      } else if (keijobiKbn === '2' && this.recHaisoMeisai.chakuchiYmd !== null && this.recHaisoMeisai.chakuchiYmd !== '' && this.recHaisoMeisai.chakuchiYmd !== undefined) {
        this.$refs.seikyuYoteiYmd.onCalendarInput(this.recHaisoMeisai.chakuchiYmd)
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 項目切替
    // ----------------------------------------------------------------------------------------------------
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = f
    },
    onSwitchingHatsuchiCodeToBiko (f) {
      this.hatsuchiSwitch = f
    },
    onSwitchingHatsuchiHmsToBiko (f) {
      this.hatsuchiHmsSwitch = f
    },
    onSwitchingChakuchiCodeToBiko (f) {
      this.chakuchiSwitch = f
    },
    onSwitchingChakuchiHmsToBiko (f) {
      this.chakuchiHmsSwitch = f
    },
    onExpandKeiyuchi: function () {
      this.expandKeiyuchi = !this.expandKeiyuchi
    },

    // ----------------------------------------------------------------------------------------------------
    // フィルタ補助
    // ----------------------------------------------------------------------------------------------------
    hacchakuchiFilter (elem) {
      const self = this
      const target = filter.dateFormatter(new Date())
      return (elem.tekiyoStartYmdDisp <= target) &&
            (elem.tekiyoEndYmdDisp >= target) &&
            (!self.selectNinushiCd || (elem.torihikisakiCd === self.selectNinushiCd || elem.torihikisakiCd === null))
    },

    // ----------------------------------------------------------------------------------------------------
    // 距離計算補助
    // ----------------------------------------------------------------------------------------------------
    setYoteiSokoKyori: function (e) {
      this.$set(this.rec, 'yoteiSokoKyori', e.kyoriKm)
    },

    // ----------------------------------------------------------------------------------------------------
    // 時間計算補助
    // ----------------------------------------------------------------------------------------------------
    calcTime: function (p) {
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToIntervalTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToIntervalTimeFormatter(min)
      }
      return result
    },
    // ----------------------------------------------------------------------------------------------------
    // 請求補助
    // ----------------------------------------------------------------------------------------------------
    inputTaikiJikan: function () {
      if (this.rec.taikiJikan) {
        this.$set(this.rec, 'taikiJikan', this.calcTime(String(this.rec.taikiJikan)))
      }
    },
    calcTaikiJikanKingaku: function () {
      let taikiJikan = this.rec.taikiJikan
      let taikiJikanTanka = this.rec.taikiJikanTanka

      if (taikiJikan === undefined || taikiJikan === '' || taikiJikan === null) { taikiJikan = '00:00' }
      if (taikiJikanTanka === undefined || taikiJikanTanka === '' || taikiJikanTanka === null) { taikiJikanTanka = 0 }

      taikiJikan = filter.timeToMinFormatter(taikiJikan)

      const taikiJikanKingaku = this.calcFraction((taikiJikan / 60) * taikiJikanTanka)
      this.$set(this.rec, 'taikiJikanKingaku', taikiJikanKingaku)
    },
    inputYoteiSagyoJikan: function () {
      if (this.rec.yoteiSagyoJikan) {
        this.$set(this.rec, 'yoteiSagyoJikan', this.calcTime(this.rec.yoteiSagyoJikan))
      }
    },
    setHachhakuchiTanka: function (e) {
      let temp = Object.assign({}, this.rec)
      temp = {
        ...temp,
        /*
        tantoEigyoshoId: e.eigyoshoCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', e.eigyoshoCd, this.baseYmd).id : temp.tantoEigyoshoId,
        tokuisakiId: e.torihikisakiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.torihikisakiList, 'torihikisakiCd', e.torihikisakiCd, this.baseYmd).id : temp.tokuisakiId,
        mstHinmeiId: e.hinmeiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.hinmeiList, 'hinmeiCd', e.hinmeiCd, this.baseYmd).id : temp.mstHinmeiId,
        seikyuShashuSbt: e.unchinShashuSbt,
        */
        unchinKeisanKbn: e.unchinKeisanKbn,
        tanka: e.tanka,
        hiwayPrice: e.hiwayPrice,
        hokanKingaku: e.userKingakuKazei4,
        niekiKingaku: e.userKingakuKazei3,
        unchinHokaKingaku: e.userKingakuKazei1,
        unchinHokaHikazei: e.userKingakuHikazei1,
        tatekaekinHikazei: e.userKingakuHikazei2,
        warimashiSonotaKingaku: e.userKingakuKazei2
      }
      this.rec = Object.assign({}, temp)
      temp = undefined
    },

    // ----------------------------------------------------------------------------------------------------
    // 割増補助
    // ----------------------------------------------------------------------------------------------------
    inputWarimashiTaishoJikan: function () {
      if (this.rec.warimashiTaishoJikan) {
        this.$set(this.rec, 'warimashiTaishoJikan', this.calcTime(this.rec.warimashiTaishoJikan))
      }
    },
    calcJikanWarimashiKingaku: function () {
      if (this.rec.warimashiTaishoJikan && this.rec.warimashiJikanTanka) {
        let warimashiTaishoJikan = this.rec.warimashiTaishoJikan
        let warimashiJikanTanka = this.rec.warimashiJikanTanka

        if (warimashiTaishoJikan === undefined || warimashiTaishoJikan === '') { warimashiTaishoJikan = 0 }
        if (warimashiJikanTanka === undefined || warimashiJikanTanka === '') { warimashiJikanTanka = 0 }

        warimashiTaishoJikan = filter.timeToMinFormatter(warimashiTaishoJikan)
        const jikanWarimashiKingaku = this.calcFraction((warimashiTaishoJikan / 60) * warimashiJikanTanka)
        this.$set(this.rec, 'jikanWarimashiKingaku', jikanWarimashiKingaku)
      } else {
        this.$set(this.rec, 'jikanWarimashiKingaku', null)
      }
    },
    calcKyoriWarimashiKingaku: function () {
      if (this.rec.warimashiTaishoKyori && this.rec.warimashiKyoriTanka) {
        let warimashiTaishoKyori = this.rec.warimashiTaishoKyori
        let warimashiKyoriTanka = this.rec.warimashiKyoriTanka

        if (warimashiTaishoKyori === undefined || warimashiTaishoKyori === '') { warimashiTaishoKyori = 0 }
        if (warimashiKyoriTanka === undefined || warimashiKyoriTanka === '') { warimashiKyoriTanka = 0 }

        const kyoriWarimashiKingaku = this.calcFraction(warimashiTaishoKyori * warimashiKyoriTanka)
        this.$set(this.rec, 'kyoriWarimashiKingaku', kyoriWarimashiKingaku)
      } else {
        this.$set(this.rec, 'kyoriWarimashiKingaku', null)
      }
    },
    calcFraction: function (x) {
      if ([undefined, null, ''].includes(this.rec) || [undefined, null, ''].includes(this.rec.unchinHasuKeisanKbn)) {
      // 初期設定は四捨五入としておく
        x = Math.round(x)
      } else if (this.rec.unchinHasuKeisanKbn === '01') {
      // 切り捨て
        x = Math.floor(x)
      } else if (this.rec.unchinHasuKeisanKbn === '02') {
      // 四捨五入
        x = Math.round(x)
      } else if (this.rec.unchinHasuKeisanKbn === '03') {
      // 切り上げ
        x = Math.ceil(x)
      }
      return x
    },
    // --------------------------------------------------
    // IndexedDB取得
    // --------------------------------------------------
    setTantoEigyosho: function () {
      if (this.rec.tantoEigyoshoId) {
        this.rec.tantoEigyoshoCd = indexeddb.getRecord(this.eigyoshoList, this.rec.tantoEigyoshoId).eigyoshoCd
      }
    },
    setHinmei: function () {
      if (this.rec.mstHinmeiId) {
        this.rec.hinmeiCd = indexeddb.getRecord(this.hinmeiList, this.rec.mstHinmeiId).hinmeiCd
      }
    },
    setHatsuchiId: function () {
      if (this.rec.hatsuchiId) {
        this.rec.hatsuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.rec.hatsuchiId).hacchakuchiCd
      }
    },
    setChakuchiId: function () {
      if (this.rec.chakuchiId) {
        this.rec.chakuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.rec.chakuchiId).hacchakuchiCd
      }
    },
    changeAutoIssueMode: function (p) {
      if (!this.autoIssueNoMode) { return }
      this.clearInvalidMessage(this.$refs)
    }
  }
}
